<template>
  <a-modal
    title="课程安排"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="早课时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-time-picker
            format="HH:mm"
            v-decorator="[
              'am_course_time',
              {
                initialValue: !model.am_course_time
                  ? null
                  : moment(model.am_course_time, 'HH:mm'),
                rules: [{ required: true, message: '请输入早课时间' }]
              }
            ]"
          />
        </a-form-item>
        <a-form-item
          label="午课时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-time-picker
            format="HH:mm"
            v-decorator="[
              'noon_course_time',
              {
                initialValue: !model.noon_course_time
                  ? null
                  : moment(model.noon_course_time, 'HH:mm'),
                rules: [{ required: true, message: '请选择午课时间' }]
              }
            ]"
          />
        </a-form-item>
        <a-form-item
          label="晚课时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-time-picker
            format="HH:mm"
            v-decorator="[
              'pm_course_time',
              {
                initialValue: !model.pm_course_time
                  ? null
                  : moment(model.pm_course_time, 'HH:mm'),
                rules: [{ required: true, message: '请输入晚课时间' }]
              }
            ]"
          />
        </a-form-item>
        <a-form-item
          label="开课时间为T, T+"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :max-length="3"
            type="number"
            style="width: 100px"
            placeholder="请输入"
            v-decorator="[
              'day_add_t',
              {
                rules: [{ required: true, message: '请输入' }]
              }
            ]"
          ></a-input
          >日开始正式授课
        </a-form-item>
        <a-form-item
          label="不同课程时间间隔"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :max-length="3"
            type="number"
            style="width: 100px"
            placeholder="请输入"
            v-decorator="[
              'day_interval',
              {
                rules: [{ required: true, message: '请输入' }]
              }
            ]"
          ></a-input
          >天
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import Bus from './modlues/bus';
import { axios } from '@/utils/request';
import pick from 'lodash.pick';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
import JImageUpload from '@/components/jeecg/JImageUpload';
import JUpload from '@/components/jeecg/JUpload';
import moment from 'moment';

export default {
  name: 'CourseDetailModal',
  components: {
    JDictSelectTag,
    JImageUpload,
    JUpload
  },
  data() {
    return {
      form: this.$form.createForm(this),
      width: 600,
      visible: false,
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      url: {}
    };
  },
  methods: {
    moment,
    // 通过混入打开弹窗并进行进一步操作
    add(course) {
      this.edit(course);
    },
    async edit(record) {
      console.log(record, '+++++++++++++++++++++++++++++++++');
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.title = '课程安排';
      this.$nextTick(() => {
        console.log('1111', this.model);
        this.form.setFieldsValue(pick(this.model, 'day_add_t', 'day_interval'));
        this.form.validateFields((err, values) => {
          console.log('2222', values);
        });
      });
    },
    close() {
      this.visible = false;
    },
    // 确认按钮的回调
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          values.id = that.model.id;
          values.dayAddT = values.day_add_t;
          values.dayInterval = values.day_interval;
          values.amCourseTime = moment(values.am_course_time).format(
            'HH:mm:ss'
          );
          values.noonCourseTime = moment(values.noon_course_time).format(
            'HH:mm:ss'
          );
          values.pmCourseTime = moment(values.pm_course_time).format(
            'HH:mm:ss'
          );
          // 修改课程时间接口，接口接收数据格式有问题，没有封装
          axios({
            url: process.env.VUE_APP_CMS_COURSE + '/course/updateCourseTime',
            method: 'post',
            data: values
          })
            .then(res => {
              that.confirmLoading = false;
              that.visible = false;
              Bus.$emit('getTime', values);
              console.log(res);
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    },
    // 关闭弹窗
    handleCancel() {
      this.close();
    }
  }
};
</script>
<style>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
